<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title" v-text="nameList[showImage]">

            </div>
            <div class="content" v-if="showImage == 1">
                <div>
                    <img class="left" src="../../assets/images/hangtohang.jpg" />
                    <img class="right" src="../../assets/images/sddq.jpg" />
                </div>
                <div class="clear"></div>
                <div class="margin-top">
                    <img class="right" src="../../assets/images/xiong.jpg" />
                    <img class="left" src="../../assets/images/diedfish.jpg" />
                </div>
            </div>
            <div class="content" v-if="showImage == 2">
                <div>
                    <img class="left" src="../../assets/images/lovehome.jpg" />
                    <img class="right" src="../../assets/images/wa1e.jpg" />
                </div>
                <div class="clear"></div>
                <div class="margin-top">
                    <img class="right" src="../../assets/images/earth4.jpg" />
                    <img class="left" src="../../assets/images/wt.jpg" />
                </div>
            </div>
            <div class="content" v-if="showImage == 3">
                <div>
                    <img class="left" src="../../assets/images/d1.jpg" />
                    <img class="right" src="../../assets/images/love.jpg" />
                </div>
                <div class="clear"></div>
                <div class="margin-top">
                    <img class="right" src="../../assets/images/wcrun.jpg" />
                    <img class="left" src="../../assets/images/d2.jpg" />
                </div>
            </div>
            <div class="content" v-if="showImage == 4">
                <div>
                    <img class="left" src="../../assets/images/h4.jpg" />
                    <img class="right" src="../../assets/images/h3.jpg" />
                </div>
                <div class="clear"></div>
                <div class="margin-top">
                    <img class="right" src="../../assets/images/h2.jpg" />
                    <img class="left" src="../../assets/images/h1.jpg" />
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    export default {
        name: "InitiativeView",
        props: ["showImage"],
        data() {
            return {
                nameList: [
                    "",
                    "图片1",
                    "图片2",
                    "图片3-灾难-地震",
                    "图片4-灾难(特效)-火山",
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            .content {
                margin-top: 50px;
            }
            img {
                width: 40%;
                height: 200px;
            }
            .left {
                float: left;
            }
            .right {
                float: right;
            }
            .margin-top {
                margin-top: 50px;
            }
        }
    }
</style>